module.exports = __webpack_public_path__ + "img/40.a075c35e.png";